import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../../../../environments/environment";
import { Observable } from "rxjs";
import { StarsDeliveryResponse } from "../interfaces/stars-delivery.interface";

@Injectable({
  providedIn: 'root'
})

export class StarsDeliveryService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {

  }


  loadStarsDelivery(IdDelivery: number) :Observable<StarsDeliveryResponse>{
    return this.http.post<StarsDeliveryResponse>(`${this.apiUrl}/ratingDelivery`, { IdDelivery });
  }
}
